<template>
  <el-card class="my-birthday" shadow="hover" v-loading="loading">
    <template #header>
      <div style="font-weight:700; font-size:16px;">🎂 생년월일</div>
    </template>

    <el-form :model="form" label-position="top">
      <el-form-item label="생년월일">
        <el-date-picker
          v-model="form.birth_date"
          type="date"
          format="YYYY-MM-DD"
          value-format="YYYY-MM-DD"
          placeholder="YYYY-MM-DD"
          :disabled="locked"
          style="width: 100%;"
        />
      </el-form-item>
      <el-form-item>
        <el-checkbox v-model="form.birth_date_is_lunar" :disabled="locked">
          음력 생일
        </el-checkbox>
      </el-form-item>

      <el-alert v-if="locked" type="warning" :closable="false" show-icon style="margin-bottom: 10px;">
        <template #title>
          생일이 확정되어 본인이 직접 변경할 수 없습니다. 인사담당자에게 변경 요청해주세요.
        </template>
      </el-alert>

      <el-alert v-else-if="form.birth_date_changed_count > 0"
        type="info" :closable="false" show-icon style="margin-bottom: 10px;">
        <template #title>
          남은 자동 변경 가능 횟수:
          {{ Math.max(0, allowedCount - form.birth_date_changed_count) }}회
        </template>
      </el-alert>

      <el-button type="primary" @click="onSave" :disabled="locked || !form.birth_date">
        저장
      </el-button>
    </el-form>
  </el-card>
</template>

<script setup>
import { ref, computed, onMounted } from 'vue'
import { ElMessage } from 'element-plus'
import axiosInstance from '@/api/axios'

const loading = ref(false)
const form = ref({
  birth_date: null,
  birth_date_is_lunar: false,
  birth_date_locked_at: null,
  birth_date_changed_count: 0,
})
const allowedCount = ref(1)

const locked = computed(() => !!form.value.birth_date_locked_at)

async function fetchData() {
  loading.value = true
  try {
    const [me, policy] = await Promise.all([
      axiosInstance.get('me/birthday/'),
      axiosInstance.get('birthday-policy/'),
    ])
    form.value = { ...form.value, ...me.data }
    if (policy.data && typeof policy.data.allow_self_change_count === 'number') {
      allowedCount.value = policy.data.allow_self_change_count
    }
  } catch (e) {
    console.error(e)
  } finally {
    loading.value = false
  }
}

async function onSave() {
  if (locked.value) return
  loading.value = true
  try {
    const r = await axiosInstance.patch('me/birthday/', {
      birth_date: form.value.birth_date,
      birth_date_is_lunar: form.value.birth_date_is_lunar,
    })
    form.value = { ...form.value, ...r.data }
    ElMessage.success('생일이 저장되었습니다 🎂')
  } catch (e) {
    const msg = e?.response?.data?.detail
      || (Array.isArray(e?.response?.data) ? e.response.data.join('\n') : null)
      || JSON.stringify(e?.response?.data || e.message)
    ElMessage.error(msg)
  } finally {
    loading.value = false
  }
}

onMounted(fetchData)
</script>
